export default __webpack_public_path__ + "static/media/grey.86377101.hdr";